// extracted by mini-css-extract-plugin
export default {"customDialog":"FundExpenseDetail_customDialog__JUg8m"};